{
  "id": 12,
  "location": "cafe",
  "difficulty": "normal",
  "moves": 21,
  "kinds": 6,
  "goals": [
    { "type": "collect", "kind": "croissant", "count": 30 },
    { "type": "mud" }
  ],
  "stars": [3350, 4440],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . X . x . .",
    ". . . X . x . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.856, "movesLeft": 6, "closeLosses": 0.066, "target": 0.87 }
}
